var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Current_Location",
    "data-name": "Current Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M34.851,31.5A3.351,3.351,0,1,0,38.2,34.851,3.351,3.351,0,0,0,34.851,31.5Zm0,5.46a2.11,2.11,0,1,1,2.11-2.11,2.11,2.11,0,0,1-2.11,2.11Z",
    transform: "translate(-24.851 -24.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M19.444,9.444h-2.8a6.667,6.667,0,0,0-6.087-6.087V.556a.556.556,0,1,0-1.111,0v2.8A6.667,6.667,0,0,0,3.358,9.444H.556a.556.556,0,1,0,0,1.111h2.8a6.667,6.667,0,0,0,6.087,6.087v2.8a.556.556,0,0,0,1.111,0v-2.8a6.667,6.667,0,0,0,6.087-6.087h2.8a.556.556,0,0,0,0-1.111Zm-8.889,6.082v-.86a.556.556,0,0,0-1.111,0v.86a5.556,5.556,0,0,1-4.971-4.971h.86a.556.556,0,0,0,0-1.111h-.86A5.556,5.556,0,0,1,9.444,4.473v.86a.556.556,0,0,0,1.111,0v-.86a5.556,5.556,0,0,1,4.971,4.971h-.86a.556.556,0,0,0,0,1.111h.86a5.556,5.556,0,0,1-4.971,4.971Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationType);
export default __webpack_public_path__ + "static/media/locationType.dc7f6093.svg";
export { ForwardRef as ReactComponent };